(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["background-image"] && !Shopify.designMode) return;
  try {
    class BackgroundImageParallax {
    constructor() {
      this.elements = document.querySelectorAll('[data-parallax="true"]');
      this.ticking = false;
      this.mouseX = 0;
      this.mouseY = 0;
      
      // Check for reduced motion preference
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      
      if (!this.prefersReducedMotion && this.elements.length > 0) {
        this.init();
      }
    }
    
    init() {
      // Use mousemove on document for better performance
      document.addEventListener('mousemove', (e) => {
        this.mouseX = e.clientX;
        this.mouseY = e.clientY;
        
        if (!this.ticking) {
          window.requestAnimationFrame(() => {
            this.updateParallax();
            this.ticking = false;
          });
          this.ticking = true;
        }
      });
      
      // Initial update
      this.updateParallax();
    }
    
    updateParallax() {
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;
      
      this.elements.forEach((element) => {
        const intensity = parseFloat(element.dataset.parallaxIntensity) || 20;
        const direction = element.dataset.parallaxDirection || 'inverse';
        const side = element.dataset.side || 'left';
        const rotation = parseFloat(element.dataset.rotation) || 0;
        
        // Calculate mouse position relative to center (-1 to 1)
        const relativeX = (this.mouseX - centerX) / centerX;
        const relativeY = (this.mouseY - centerY) / centerY;
        
        // Apply movement based on direction
        const directionMultiplier = direction === 'inverse' ? -1 : 1;
        const moveX = relativeX * intensity * directionMultiplier;
        const moveY = relativeY * intensity * directionMultiplier;
        
        // Apply transform based on side
        if (side === 'left') {
          element.style.transform = `translate(calc(-50% + ${moveX}px), calc(-50% + ${moveY}px)) rotate(${rotation}deg)`;
        } else {
          element.style.transform = `translate(calc(50% + ${moveX}px), calc(-50% + ${moveY}px)) rotate(${rotation}deg)`;
        }
      });
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new BackgroundImageParallax();
    });
  } else {
    new BackgroundImageParallax();
  }
  
  // Reinitialize on section:load for Shopify theme editor
  document.addEventListener('shopify:section:load', () => {
    new BackgroundImageParallax();
  });
  } catch(e) { console.error(e); }
})();

})();
